// Use this width after we expand the folder pane from collapsed state and the stored width for folder pane is not valid.
export const DEFAULT_FOLDER_PANE_WIDTH = 228;

// Min width threshold for resizing in navigation. Below this number we consider the panel collapsed.
export const MIN_FOLDER_PANE_WIDTH = 198;

// Max width threshold for resizing in navigation. Users are not able to resize folder pane beyond this value.
export const MAX_FOLDER_PANE_WIDTH = 400;

// Min Reading Pane Width
export const MIN_READING_PANE_WIDTH = 370;

// Max list view dimensions allowed
export const MAX_LIST_VIEW_WIDTH_SLV_RP: number = 625; // Max list view width allowed when using SLV with a right docked Reading Pane
export const MAX_LIST_VIEW_HEIGHT: number = 800;

// Min list view dimensions
export const MIN_LIST_VIEW_WIDTH: number = 350;
export const MIN_LIST_VIEW_HEIGHT: number = 150;

export const LIST_VIEW_NOTIFICATION_PADDING_V9: number = 60;
